import { render, staticRenderFns } from "./chat-commands.vue?vue&type=template&id=310f019b&scoped=true&"
import script from "./chat-commands.vue?vue&type=script&lang=js&"
export * from "./chat-commands.vue?vue&type=script&lang=js&"
import style0 from "./chat-commands.vue?vue&type=style&index=0&id=310f019b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f019b",
  null
  
)

export default component.exports